import { Component } from '@angular/core';
import { NavController, NavParams, AlertController, ModalController } from 'ionic-angular';
import { DIC } from '../../dic';
import * as moment from 'moment'
import { GN } from '../../../gn';

/**
 * Generated class for the PricesbydayPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-pricesbyday',
  templateUrl: 'pricesbyday.html',
})
export class PricesbydayPage {
  selectedDay: any;

  _electricityPrice = 0;
  _gasolinePrice = 0
  _dieselPrice = 0
  _lpgPrice = 0

  _electricityPricePrev = 0;
  _gasolinePricePrev = 0
  _dieselPricePrev = 0
  _lpgPricePrev = 0

  _electricityBalance = '';
  _gasolineBalance = '';
  _dieselBalance = '';
  _lpgBalance = '';

  _electricityArr = '';
  _gasolineArr = '';
  _dieselArr = '';
  _lpgArr = '';

  _hasElectricity = '';
  _hasGasoline = '';
  _hasDiesel = '';
  _hasLpg = '';


  constructor(public navCtrl: NavController, public navParams: NavParams, public dic: DIC, public gn: GN, public alertCtrl: AlertController, public modalCtrl: ModalController) {
    this.selectedDay = moment(navParams.get('selectedDay')).format(this.gn.user.DFormat);

    this._electricityPrice = navParams.get('obj').electricity;
    this._gasolinePrice = navParams.get('obj').gasoline;
    this._dieselPrice = navParams.get('obj').diesel;
    this._lpgPrice = navParams.get('obj').lpg;

    this._electricityPricePrev = navParams.get('obj').prevelectricity;
    this._hasElectricity = navParams.get('obj').prevelectricity;
    this._gasolinePricePrev = navParams.get('obj').prevgasoline;
    this._hasGasoline = navParams.get('obj').prevgasoline;
    this._dieselPricePrev = navParams.get('obj').prevdiesel;
    this._hasDiesel = navParams.get('obj').prevdiesel;
    this._lpgPricePrev = navParams.get('obj').prevlpg;
    this._hasLpg = navParams.get('obj').prevlpg;

    if (this._hasElectricity != '/') {
      this._electricityBalance = this.RoundFixed(this._electricityPrice - this._electricityPricePrev) + ''
      if ((this._electricityPrice - this._electricityPricePrev) > 0) {
        this._electricityBalance = '+' + this.RoundFixed(this._electricityBalance) + ''
        this._electricityArr = '⬆';
      } else {
        this._electricityArr = '⬇';
      }
      this._electricityBalance += ' ден'
    }

    if (this._hasGasoline != '/') {
      this._gasolineBalance = this.RoundFixed(this._gasolinePrice - this._gasolinePricePrev) + ''
      if ((this._gasolinePrice - this._gasolinePricePrev) > 0) {
        this._gasolineBalance = '+' + this.RoundFixed(this._gasolineBalance) + ''
        this._gasolineArr = '⬆';
      } else {
        if (this._gasolineBalance == '0.0') this._gasolineBalance = '-0.0';
        this._gasolineArr = '⬇';
      }
      this._gasolineBalance += ' ден'
    }

    if (this._hasDiesel != '/') {
      this._dieselBalance = this.RoundFixed(this._dieselPrice - this._dieselPricePrev) + ''
      if ((this._dieselPrice - this._dieselPricePrev) > 0) {
        this._dieselBalance = '+' + this.RoundFixed(this._dieselBalance) + ''
        this._dieselArr = '⬆';
      } else {
        if (this._dieselBalance == '0.0') this._dieselBalance = '-0.0';
        this._dieselArr = '⬇';
      }
      this._dieselBalance += ' ден'
    }

    if (this._hasLpg != '/') {
      this._lpgBalance = this.RoundFixed(this._lpgPrice - this._lpgPricePrev) + ''
      if ((this._lpgPrice - this._lpgPricePrev) > 0) {
        this._lpgBalance = '+' + this.RoundFixed(this._lpgBalance) + ''
        this._lpgArr = '⬆';
      } else {
        if (this._lpgBalance == '0.0') this._lpgBalance = '-0.0';
        this._lpgArr = '⬇';
      }
      this._lpgBalance += ' ден'
    }
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad PricesbydayPage');
    var _that = this
    // for (let i = 0; i < _that.gr.length; i++) {    
    //   _that.gr[i].datum1 = moment(_that.gr[i].datum).format('DD-MM-YYYY')
    // }
  }



  RoundFixed(_txt) {
    var rounded = Math.round(_txt * 10) / 10
    return rounded.toFixed(1);
  }
}



// WEBPACK FOOTER //
// ./src/pages/settings/energycalendar/pricesbyday.ts